"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const jsxRuntime = require("react/jsx-runtime");
const foundations_icons_Icon = require("../../../foundations/icons/Icon.js");
const getFeedbackIcon = (variant) => {
  switch (variant) {
    case "success":
      return /* @__PURE__ */ jsxRuntime.jsx(foundations_icons_Icon.Icon, { variant: "Check2", "aria-hidden": "true" });
    case "error":
      return /* @__PURE__ */ jsxRuntime.jsx(foundations_icons_Icon.Icon, { variant: "Error", "aria-hidden": "true" });
    case "info":
      return /* @__PURE__ */ jsxRuntime.jsx(foundations_icons_Icon.Icon, { variant: "Info", "aria-hidden": "true" });
    case "warning":
      return /* @__PURE__ */ jsxRuntime.jsx(foundations_icons_Icon.Icon, { variant: "Warning", "aria-hidden": "true" });
    default:
      console.error("Invalid variant");
      return null;
  }
};
exports.getFeedbackIcon = getFeedbackIcon;
